import { PERMISSIONS } from "@/constants/permissions"
import { useFeatureFlag } from "@/contexts/FeatureFlagContext"
import useUser from "@/hooks/useUser"

/**
 * Whether this user can open the Settings > Regulations card. Mirrors the
 * backend router (MATERIAL_COMPLIANCE + MC_REGULATION_SETTINGS) and the GET
 * endpoint's MC_MASTER_DATA_VIEW. The card and every deep link to it
 * (ORG_REGULATIONS_SETTINGS_ROUTE) read this one gate, so no link points at a
 * card Settings hides: declaration permissions don't imply master-data view.
 */
export function useCanViewOrgRegulations(): boolean {
  const { hasPermission } = useUser()
  const materialComplianceEnabled = useFeatureFlag("MATERIAL_COMPLIANCE")
  const regulationSettingsEnabled = useFeatureFlag("MC_REGULATION_SETTINGS")
  return (
    materialComplianceEnabled &&
    regulationSettingsEnabled &&
    hasPermission(PERMISSIONS.MC_MASTER_DATA_VIEW)
  )
}
